import { Component, Input } from '@angular/core';
import { BaseListHeaderComponent } from '../../../list/BaseListHeader.component';

@Component({
    selector: 'admin-cutimed-list-header',
    templateUrl: 'CutimedListHeader.component.html'
})
export class CutimedListHeaderComponent<I> extends BaseListHeaderComponent<I> {
    @Input()
    useSegment = true;
}
